const points = [
  {
    icon: "ri-shake-hands-line",
    title: "Đối tác đáng tin cậy",
    desc: "Hợp tác chặt chẽ với các tổ chức tài chính uy tín tại Việt Nam, mang lại giải pháp vay vốn linh hoạt.",
  },
  {
    icon: "ri-lock-2-line",
    title: "Bảo mật tuyệt đối",
    desc: "Dữ liệu cá nhân được mã hóa và lưu trữ an toàn theo tiêu chuẩn ngân hàng quốc tế.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Hỗ trợ 24/7",
    desc: "Đội ngũ chuyên viên tư vấn luôn sẵn sàng giải đáp mọi thắc mắc của bạn mọi lúc, mọi nơi.",
  },
];

export default function About() {
  return (
    <section id="about" className="relative bg-background-50 py-20 md:py-28 px-6 md:px-10">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5">
          <p className="text-primary-600 text-sm font-semibold tracking-widest uppercase mb-4">
            Về chúng tôi
          </p>
          <h2 className="font-heading text-foreground-950 text-3xl md:text-5xl leading-tight mb-6">
            Giải pháp vay vốn{" "}
            <span className="text-primary-600">đơn giản và minh bạch</span>{" "}
            cho người Việt
          </h2>
          <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-8">
            VF Money là nền tảng vay tiêu dùng cá nhân được vận hành bởi CÔNG TY CỔ PHẦN
            KINH DOANH VF MONEY với đội ngũ chuyên gia tài chính giàu kinh nghiệm. Sứ mệnh
            của chúng tôi là giúp mọi người dễ dàng tiếp cận nguồn vốn hợp pháp khi cần
            thiết, hoàn toàn online và không phát sinh phí ẩn.
          </p>

          <div className="flex flex-wrap gap-3">
            <span className="inline-flex items-center gap-2 bg-secondary-100 text-secondary-900 text-sm font-semibold px-4 py-2 rounded-full">
              <i className="ri-checkbox-circle-fill text-secondary-700"></i>
              Đã cấp phép hoạt động
            </span>
            <span className="inline-flex items-center gap-2 bg-accent-100 text-accent-900 text-sm font-semibold px-4 py-2 rounded-full">
              <i className="ri-star-fill text-accent-600"></i>
              4.8/5 đánh giá khách hàng
            </span>
          </div>
        </div>

        <div className="lg:col-span-7 grid grid-cols-1 md:grid-cols-3 gap-4">
          {points.map((p, idx) => (
            <div
              key={p.title}
              className={`rounded-2xl p-6 border transition-all ${
                idx === 1
                  ? "bg-primary-500 text-background-50 border-primary-600 md:translate-y-6"
                  : "bg-background-100 border-background-200/70"
              }`}
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl mb-5 ${
                  idx === 1
                    ? "bg-background-50/20 text-background-50"
                    : "bg-primary-100 text-primary-600"
                }`}
              >
                <i className={`${p.icon} text-2xl`}></i>
              </div>
              <h3
                className={`font-bold text-lg mb-2 ${
                  idx === 1 ? "text-background-50" : "text-foreground-950"
                }`}
              >
                {p.title}
              </h3>
              <p
                className={`text-sm leading-relaxed ${
                  idx === 1 ? "text-background-100/90" : "text-foreground-600"
                }`}
              >
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}